import PropTypes from 'prop-types';
import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import CreateSalesforceCampaignActionMetadata from 'automation-ui-action-features/actions/create-salesforce-campaign/CreateSalesforceCampaignActionMetadata';
import CreateSalesforceCampaignActionDetail from 'automation-ui-action-features/actions/create-salesforce-campaign/CreateSalesforceCampaignActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class CreateSalesforceCampaignActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(CreateSalesforceCampaignActionDetail, {
        actionMetadata: actionMetadata
      })
    });
  }
}
CreateSalesforceCampaignActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(CreateSalesforceCampaignActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default CreateSalesforceCampaignActionHistoryCard;